/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import React from "react";
export const AbSplitButton = props => {
  const contextSize = React.useContext(AbSizeContext);
  const inner = /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-split-button", props, [props.size ?? contextSize]), props.children[0], props.children[1]);
  return sizeProviderWrapper(inner, props, contextSize);
};
//# sourceMappingURL=AbSplitButton.js.map
